import { TSessionDetails } from '@api/io/session.io';
import { useProgressTag } from '@hooks/tags/useProgressTag';
import { useSessionTags } from '@hooks/useSessionTags';
import { TSessionStates } from '@routes/session-details/utils/getSessionStates';
import { useSessionStates } from './useSessionStates';
import { Tag, useTagMap } from '@hooks/tags/useTagMap';

const TAG_STATES = [
  'waitlistFull',
  'sessionFull',
  'managerApprovalRequired',
  'disenrollmentUnavailable',
  'placedInWaitlist',
  'numberedPlaceInWaitlist',
  'enrollmentPending',
  'enrollmentPendingManagerApproval',
] as const;
type TagStates = Extract<TSessionStates, typeof TAG_STATES>;
const isTagState = (value: string): value is TagStates => {
  return TAG_STATES.includes(value as TagStates);
};

export const useSessionDetailsTags = (sessionDetails: TSessionDetails) => {
  const sessionStates = useSessionStates(sessionDetails);
  const genericTags = useSessionTags(sessionDetails);
  const progressTag = useProgressTag(sessionDetails.selfEnrollmentProgress);
  const tagMap = useTagMap({
    waitlistSeatNumber: sessionDetails.waitlist?.seatNumber,
  });

  const sessionStateTags = Object.entries(sessionStates).reduce(
    (acc, [key, value]) => {
      if (value && isTagState(key)) {
        return {
          ...acc,
          [key]: tagMap[key as TagStates],
        };
      }

      return acc;
    },
    {} as Record<TSessionStates, Tag>,
  );

  return {
    progressTag,
    ...genericTags,
    ...sessionStateTags,
  };
};
